import { CompanyPaths } from "Company/Routes/Routing";
import { type CompanyCreateDto, postCompanies } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { COMPANY_LIST } from "../Query/useCompanyListQuery";

const companyMutationsResource = Resources.base.company.mutations;

export const useCreateCompany = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationFn: processResponse((data: CompanyCreateDto) =>
			postCompanies(data),
		),
		onError: (error) => {
			console.error(
				`${t(companyMutationsResource.companyCreateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(companyMutationsResource.companyCreateSuccess));
			navigate(CompanyPaths.Index.path);
			queryClient.invalidateQueries({ queryKey: [COMPANY_LIST] });
		},
	});
};
